import { Component, computed, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon } from '../../icon/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'li[app-heart-rate-data-block-item]',
  imports: [Icon, DataItemTemplate, TranslateModule],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      <app-icon [size]="iconSize()" class="icon" icon="cardio" />
      @if (!isFlip()) {
        <p class="name" translate>common.metric.heartrate.short</p>
        <p class="value">{{ value() }}</p>
      } @else {
        <p class="name" translate>common.metric.heartrate.avg</p>
        <p class="value">
          <span class="value">{{ average() }}</span>
        </p>
      }
    </app-data-item-template>
  `,
  styleUrl: './heart-rate-data-block-item.scss',
})
export class HeartRateDataBlockItem extends DataItemTemplate {
  value: Signal<number> = computed(() => Math.round(this.broadcastData().heartRate));
  average: Signal<number> = computed(() => Math.round(this.broadcastData().avgHeartRate));
}
